var WordPopup = function(wordZone, product_id, related_brochures) {
    var _this = this,
        _wordPopup = document.getElementById('word-popup'),
        _iscroll,
        product_name;
    // _product_id = wordZone.dataset.;

    // function _positionWordPopup(){

    //  var left, top;

    //  var brochureView = document.getElementsByClassName("html-slide")[0];

    //  var coordinatesOfClickedElement = wordZone.getBoundingClientRect();

    //  _wordPopup.style.left = (coordinatesOfClickedElement.left + 20)  + 'px';
    //  _wordPopup.style.top = (coordinatesOfClickedElement.top + 20) + 'px';

    //  var coordinatesOfWordPopup = _wordPopup.getBoundingClientRect();

    //  if((coordinatesOfWordPopup.bottom - brochureView.offsetHeight) > 0){
    //      top = coordinatesOfWordPopup.top - _wordPopup.offsetHeight;
    //      _wordPopup.style.top = top + 'px';
    //  }

    //  if((coordinatesOfWordPopup.left) > brochureView.offsetWidth){
    //      left = coordinatesOfWordPopup.left - _wordPopup.offsetWidth;
    //      _wordPopup.style.left = left + 'px';
    //  }
    //  // else if((coordinatesOfWordPopup.right) > brochureView.offsetWidth){
    //  //  left = coordinatesOfWordPopup.left - 500;
    //  //  _wordPopup.style.left = left + 'px';
    //  // }

    // }

    function _startScroll() {

        var $elementToActivate = document.getElementsByClassName("wp-iscroll")[0],
            $innerDiv = document.getElementsByClassName("wp-iscroll-inner")[0];

        if (_iscroll !== undefined) {
            _iscroll.refresh();
            _iscroll.destroy();
        }
        if ($("#word-popup .iScrollLoneScrollbar") !== undefined) {
            $("#word-popup .iScrollLoneScrollbar").remove();
        }
        if (($elementToActivate.offsetHeight < $innerDiv.offsetHeight == true)) {
            _iscroll = new IScroll('.wp-iscroll', {
                scrollbars: true,
                interactiveScrollbars: true,
                click: true,
                mouseWheel: true,
                resizeScrollbars: false,

            });
        }

    }

    function _getBrochures() {
        var device;

        (isMobile) ? device = "mobile": device = "desktop";
        $('.wp-products').empty();
        $('.wp-pr').empty();
        $('.wp-product-content').hide();
        $.ajax({
            type: "POST",
            url: '/products/related_products',
            beforeSend: _showBtnLoader,
            data: { "product_id": product_id, "related_brochures": related_brochures },
	        dataType: 'json',
            success: function(data) {
	            var eventCategory = "view-autozone-click-" + device;
                product_name = data.info.seo_link;
                _hideBtnLoader();
                // Add event to close btn
                $('#word-popup .mfp-close').attr('onclick', 'ga("send","event",{eventCategory: "' + eventCategory + '", eventAction: "close-button", eventLabel: "' + product_name + '"})');
                $('.wp-product-content p').html(data.info.name);
                $('.wp-product-content').show();
                if (data.info.picture != false) {
                    $(".wp-pr")
                        .empty()
                        .append('<div class="wp-product-image"></div>');

                    $('.wp-product-image')
                        .attr("onclick", 'ga("send","event",{eventCategory: "' + eventCategory + '", eventAction: "image-product-click", eventLabel : "' + product_name + '"})')
                        .css("background-image", "url(" + data.info.picture + ")")
                        .on('click', function(e){
                            e.stopPropagation();
                        });

                    $(".wp-popup-inner").removeClass("wp-5-products");
                } else {
                    $(".wp-popup-inner").addClass("wp-5-products");
                }
                $('.wp-product-link').attr({
                    href: data.info.link,
                    onclick: 'ga("send", "event", {eventCategory: "' + eventCategory + '", eventAction: "popup-title-product-click", eventLabel: "' + product_name + '"})'
                });
                for (var k in data.products) {
                    var opacityClass = (k % 2 === 0) ? "grey-opacity": "white-opacity";

                    var href = data.products[k]['link'];

                    $('.wp-products').append(
                        '<li>' +
                            //Brand Logo
                            '<div class="wp-logo wp-content wp-3-division">' +
                                '<a onclick=\'ga("send","event",{eventCategory: "' + eventCategory + '", eventAction: "brand-product-click", eventLabel : "' + data.products[k]['brand_name'] + '"});\' href="' + href + '" target="_blank">' +
                                    '<div class="wp-logo-img" style="background-image:url(' + data.products[k]['brand_logo'] + ')"></div>' +
                                '</a>' +
                            '</div>' +

                            // Title
                            '<div class="wp-title wp-content wp-3-division">' +
                                '<p>' +
                                    '<a onclick=\'ga("send","event",{eventCategory: "' + eventCategory + '", eventAction: "text-product-click", eventLabel : "' + product_name + '"});\' href="' + href + '" target="_blank">' + data.products[k]['text'] + '</a>' +
                                    '<span class="opacity ' + opacityClass + '"></span>' +
                                '</p>' +
                            '</div>' +

                            // Button
                            '<div class="wp-button wp-content wp-3-division">' +
                                '<a onclick=\'ga("send","event",{eventCategory: "' + eventCategory + '", eventAction: "button-product-click", eventLabel: "' + product_name + '"});\' href="' + href + '" target="_blank">' + viewLang.see_here + '</a>' +
                            '</div>' +
                        '</li>'
                    );

                }
                _startScroll();
                ga("send","event",{eventCategory: eventCategory, eventAction: "displayed-popup", eventLabel: product_name});
            }
        });
    }

    function _hideBtnLoader() {
        $('.up-btn-loader').removeClass('wp-loader-active');
    }

    function _showBtnLoader() {
        $('.up-btn-loader').addClass('wp-loader-active');
    }

    function _initWordPopup() {
        var device;
        (isMobile) ? device = "mobile": device = "desktop";



        $.magnificPopup.open({
            items: { src: _wordPopup },
            type: 'inline',
            fixedBgPos: true,
            mainClass: "wp-wrap",
            callbacks: {
                beforeOpen: _getBrochures
            }
        });
    }

    function _init() {

    }

    _init();
    _this.init = _init;
    _this.initWordPopup = _initWordPopup;
};